import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { CalendarListResponse, CalendarChannelResponse, CalendarEventsResponse, CalendarEventListRequest } from '../../interfaces/calendar';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

@Injectable()
export class CalendarService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public list(): Observable<CalendarListResponse> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'calendar/').pipe(
      map(response => {
        return <CalendarListResponse> response;
      }));
  }

  public listCalendarEvents(request: CalendarEventListRequest): Observable<CalendarEventsResponse> {
    let params = new HttpParams();
    const calendarId = request.calendarId;

    if (!calendarId) {
      return Observable.throw(new TypeError('Add a calendarId property to the request object'));
    }
    delete request.calendarId;

    Object.keys(request).forEach(key => {
      if (Array.isArray(request[key])) {
        request[key].forEach(value => params = params.append(key, value.toString()));
      } else {
        params = params.append(key, request[key]);
      }
    });

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'calendar/' + calendarId + '/event', this.options).pipe(
    map(response => {
      return <CalendarEventsResponse> response;
    }));

  }

  public listSubscribed(): Observable<CalendarListResponse> {
    return this.list();
  }

  public changeSubscription(changeRequest: {
    id: string;
    type: string;
    status: boolean;
  }): Observable<CalendarChannelResponse> {
    console.log('Requested subscripion %s %s %s', changeRequest.id, changeRequest.type, changeRequest.status);
    return Observable.create(observer => {
      observer.next();
    });
  }

  constructor(private authHttp: HttpClient) {
    this.authHttp = authHttp;
  }

}
